import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import mixins from './mixins'

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios);
import 'typeface-fira-sans';
import 'bootstrap'

//Jquery
window.$ = window.jQuery = require('jquery');

const moment = require('moment')
require('moment/locale/' + process.env.VUE_APP_MOMENT_LANGUAGE)

Vue.use(require('vue-moment'), {
  moment
})


import VueNoty from 'vuejs-noty'

Vue.use(VueNoty, {
  timeout: 4000,
  theme: 'bootstrap-v4',
  progressBar: true,
  layout: 'topRight'
});


import CountryFlag from 'vue-country-flag'

Vue.component('country-flag', CountryFlag)

import ToggleButton from 'vue-js-toggle-button'

Vue.use(ToggleButton)

import VueScrollTo from 'vue-scrollto';

Vue.use(VueScrollTo);

import '@/lib/icons'

import Infopanel from './components/helpers/Infopanel.vue'
import Speaker from './components/helpers/Speaker.vue'
import ProcessingButton from "./components/helpers/ProcessingButton";
import Loader from './components/Loader';

import VueCookieAcceptDecline from 'vue-cookie-accept-decline'

Vue.component('vue-cookie-accept-decline', VueCookieAcceptDecline)

import VueGtm from "@gtm-support/vue2-gtm";

Vue.use(VueGtm, {
  id: "GTM-MWL5RG7", // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryPararms: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}]
  defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
  enabled: false, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});


Vue.component('Infopanel', Infopanel);
Vue.component('Speaker', Speaker);
Vue.component('Loader', Loader);
Vue.component('ProcessingButton', ProcessingButton);

Vue.config.productionTip = false;

new Vue({
  mixins: [mixins],
  router,
  store,
  render: h => h(App)
}).$mount('#app');
